import { BOOKING_TRIAL_STATUS } from './../../@store/booking/booking.model';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { SubscriptionPlan } from '@vi-iot/client';

import { BookingStore, BOOKING_TABS, Platform, BookingService } from '@store';

@Component({
  selector: 'app-booking-checkout',
  templateUrl: './booking-checkout.component.html',
  styleUrls: ['./booking-checkout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookingCheckoutComponent implements OnInit, OnDestroy {
  readonly bookingTabs = BOOKING_TABS;
  readonly BOOKING_TRIAL_STATUS = BOOKING_TRIAL_STATUS;
  @Input() selectedPlatform: Platform;
  @Output() reset = new EventEmitter<void>();
  @Output() back = new EventEmitter<void>();

  BookingPlans = SubscriptionPlan;
  isSubscriptionUpdate: boolean;
  private ngUnsubscribe$ = new Subject<void>();

  constructor(public bookingStore: BookingStore, public bookingService: BookingService) {}

  ngOnInit(): void {
    this.bookingStore.isOnlyOnePlusSubscriptionSelectedToBeUpdatedToProPlan$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((result) => {
        this.isSubscriptionUpdate = result;
      });
  }

  onContinue(): void {
    if (this.isSubscriptionUpdate) {
      this.bookingStore.updateVitoguideSubscription();
    } else {
      this.bookingStore.subscribePackage();
    }
  }

  onBack(): void {
    if (this.selectedPlatform === Platform.E3 || this.selectedPlatform === Platform.Legacy) {
      this.onReset();
    } else {
      this.back.emit();
    }
  }

  onReset(): void {
    this.reset.emit();
  }

  ngOnDestroy(): void {
    this.bookingStore.resetSubscriptionsDetails();
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
